/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo,useState,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createBreadCrumbProps, useEffectOnce } from '../../../globalUtils/globalHooks';
import { aboutExicomRmsPlatformArticle,addNewChargerArticle,editChargerDetailsArticle,understandingChargerDashboardArticle,chargersFAQs, understandingDashboardArticle, understandingActiveAlarmsArticle, addChargingStationArticle, editChargingStationArticle, addNewCustomerArticle, editCustomerDetailsArticle, notificationRuleListArticle, summaryAndHistoryNotificationRuleArticle, notificationHistoryArticle, createNotificationRuleArticle, understandingSWDashboardArticle, addingSoftwareVersionArticle, deployingSoftwareVersionArticle, softwareDeploymentLogsArticle, updateChargerSettingArticle, updateChargerCommandsArticle, handlingSpuriousChargersArticle, loginLogoutArticle, genericFeaturesArticle, addingEditingOrganisationArticle, addingEditingUser, handlingRolesArticle ,understandingChargingHistoryArticle , understandingChargerLogsArticle, understandingExceptionLogsArticle, viewRuleListArticle, ruleExecutionsHistoryArticle, createRuleArticle, createRuleWithScheduledTimeArticle, usingNocDashboardLiveTopologyMapArticle , usingNocDashboardLatestAlertsArticle, usingAiSmartAssistSearchArticle, usingHelpAndFAQModuleArticle, troubleshootingOfAlarmsAndStopCodeErrorsArticle, usingDocumentationModuleArticle, addViewEditDocumentAISmartAssistArticle, nocDashboardPerformanceAnalyticsArticle, generatingAiInsightsArticle, uptimeReportArticle} from './helpAndFAQData/articlesExports';
import articlesMenu from './helpAndFAQData/articles-menu.json';
import { CustomBreadCrumbs } from '../../../globalUtils/globalExports';
import { startCase } from 'lodash';
import { Icon } from '../../../globalUtils/globalIcons';
import './HelpAndFAQArticle.css';
import HelpAndFAQArticleSteps from './HelpAndFAQArticleSteps';
import { Article, ArticleOutlined, Details } from '@mui/icons-material';

export interface IStepLabel{
    type: string,
    content: string,
    path?:string
}

interface IFAQ {
    question:string,
    answer:string
}

export type Step = {
    label: IStepLabel[],
    image: string,
    children: Step[]
}


type Article = {
    title: string,
    description: string,
    steps: Step[]
}

type Metadata = {
    who: string[],
    where: {[key:string]:string}[],
    preRequisite:string[]
}

type HelpAndFAQArticle = {
    title:string,
    metadata: Metadata,
    steps: Step[],
    articles: Article[],
    faqs: IFAQ[]
}


 export const articlesPathMap = {
        'about-exicom-rms-platform':{...aboutExicomRmsPlatformArticle},
        'login-and-logout':{...loginLogoutArticle},
        'generic-features':{...genericFeaturesArticle},
        'add-a-new-charger': {...addNewChargerArticle,faqs:chargersFAQs},
        'edit-charger-details': {...editChargerDetailsArticle,faqs:chargersFAQs},
        'understanding-charger-dashboard': {...understandingChargerDashboardArticle,faqs:chargersFAQs},
        'update-settings':{...updateChargerSettingArticle,faqs:chargersFAQs},
        'update-commands':{...updateChargerCommandsArticle,faqs:chargersFAQs},
        'spurious-chargers':{...handlingSpuriousChargersArticle,faqs:chargersFAQs},
        'understanding-dashboard': {...understandingDashboardArticle},
        'understanding-active-alarms': {...understandingActiveAlarmsArticle},
        'add-a-new-charging-station-via-charging-stations-screen': {...addChargingStationArticle},
        'edit-charging-station-details':{...editChargingStationArticle},
        'adding-a-new-customer':{...addNewCustomerArticle},
        'edit-customer-details':{...editCustomerDetailsArticle},
        'view-the-notification-rules-list': {...notificationRuleListArticle},
        'summary-and-history-of-notification-rule':{...summaryAndHistoryNotificationRuleArticle},
        'notifications-history':{...notificationHistoryArticle},
        'create-notification-rule':{...createNotificationRuleArticle},
        'understanding-software-version-dashboard':{...understandingSWDashboardArticle},
        'adding-a-software-version-release':{...addingSoftwareVersionArticle},
        'deploying-software-version':{...deployingSoftwareVersionArticle},
        'view-software-version-deployment-logs':{...softwareDeploymentLogsArticle},
        'adding-or-editing-an-organisation':{...addingEditingOrganisationArticle},
        'adding-or-editing-a-user':{...addingEditingUser},
        'handling-roles':{...handlingRolesArticle},
        'understanding-charging-history-report':{...understandingChargingHistoryArticle},
        'understanding-charger-logs-report':{...understandingChargerLogsArticle},
        'understanding-exception-logs':{...understandingExceptionLogsArticle},
        'view-the-rules-list':{...viewRuleListArticle},
        'rule-executions-history':{...ruleExecutionsHistoryArticle},
        'create-rule':{...createRuleArticle},
        'create-rule-with-scheduled-time':{...createRuleWithScheduledTimeArticle},
        'using-noc-dashboard-live-topology-map':{...usingNocDashboardLiveTopologyMapArticle},
        'using-noc-dashboard-latest-alerts':{...usingNocDashboardLatestAlertsArticle},
        'using-ai-smart-assist-search':{...usingAiSmartAssistSearchArticle},
        'using-help-and-faq-module':{...usingHelpAndFAQModuleArticle},
        'troubleshooting-of-alarms-and-stop-code-errors':{...troubleshootingOfAlarmsAndStopCodeErrorsArticle},
        'using-the-documentation-module':{...usingDocumentationModuleArticle},
        'add-view-and-edit-a-document-in-ai-smart-assist':{...addViewEditDocumentAISmartAssistArticle},
        'using-noc-dashboard-performance-analytics': {...nocDashboardPerformanceAnalyticsArticle},
        'generating-ai-insights': {...generatingAiInsightsArticle},
        'understanding-uptime-report': {...uptimeReportArticle}
    }



const HelpAndFAQArticle:React.FC = ()=>{
    const location = useLocation();
    // const dispatch = useAppDispatch();
    // const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const articleName = queryParams?.get('article')?.trim()?.toLowerCase() ?? 'add-new-charger';
    const selectedTopic = location?.state?.topic ? location?.state?.topic : location?.pathname?.split('/')?.[2]
    const [selectedSubArticle,setSelectedSubArticle] = useState<string | null> (null);
    const [expandedSectionMenuItem,setExpandedSectionMenuItem] = useState<string[]>([]);
    const [expandedFAQs,setExpandedFAQs] = useState<number[]>([]);


    console.log(articleName)

    const articleData:HelpAndFAQArticle = articlesPathMap[articleName]

    const breadCrumbArray = useMemo(()=>createBreadCrumbProps(
        {
            breadCrumbProps: [
                {
                    objectType: 'link',
                    id: 'supportCentre',
                },
                {
                    objectType: 'link',
                    id: 'helpAndFaq'
                },
                {
                    objectType: 'text',
                    id: 'text',
                    text: startCase(selectedTopic)
                }
            ]
        }
    ),[selectedTopic])


    const relatedArticlesList = useMemo(()=>{
        return articleData?.articles?.map((article)=>{
            const articlePath = article?.title?.toLowerCase()?.split(' ')?.join('-');
            return {
                label:article?.title,
                path:articlePath
            }
        })
    },[articleData])


    const handleScrollToArticle = (articlePath:string) : void => {
        /*
            Handles the scroll to the specific article

            Args:
                articlePath: id of the desired article
        */

        const container = document.getElementsByClassName('help__and__faq__article-body-right')?.[0] as HTMLDivElement;
        const element = document.getElementById(articlePath)
        if(!container || !element)return;
        
        setSelectedSubArticle(articlePath)

        // Todo : implement the logic to bring article on the top
        const elementY = element.offsetTop - container.offsetTop - 10 ;

        container.scrollTo({
            top: elementY,
            behavior: 'smooth'
        });
    }


    const sectionsList = Object.values(articlesMenu)

    const handleToggleSectionListItemExpansion = (sectionId:string): void =>{
        /*
            Handle expansion and collapse of the menu item

            Args:
                sectionId: unique id of each section
        */
        let newItemList:string[] = [];
        if(expandedSectionMenuItem?.includes(sectionId)){
            newItemList = expandedSectionMenuItem?.filter(id=>id!=sectionId)
        }
        else{
            newItemList = [...expandedSectionMenuItem,sectionId]
        }
        setExpandedSectionMenuItem(newItemList)
    }

    const handleSubSectionItemClicked = (e:React.MouseEvent<HTMLDivElement>,sectionName:string,subSectionName:string) : void => {
        /*
            Handles the sub-section item click and loads the corresponding article

            Args:
                subSectionName: Title of the article.
         */

        e.preventDefault();
        e.stopPropagation();
        navigate(`/help-and-faq/${sectionName}?article=${subSectionName}`,
            {
                state:{
                    topic:sectionName
                }
            }
        )
        setSelectedSubArticle(null);
        setExpandedFAQs([]);
        window.scrollTo(0, 0);
        
    }

    const allowedRolesTilesColor = [
        {
            background:'#FFE3E3',
            text:'#FB6666'
        },
        {
            background:'#E8E3FF',
            text:'#7757DE'
        },
        {
            background:'#DFF8EA',
            text:'#1E9A56'
        },
        {
            background:'#E6DEFF',
            text:'#6F42C1'
        },
        {
            background:'#FFF3D4',
            text:'#C97A10'
        },
        {
            background:'#E1F0FF',
            text:'#3A6EA5'
        },
        {
            background:'#FFE4CC',
            text:'#D2651A'
        },
        {
            background:'#DFF8EA',
            text:'#1E9A56'
        },
        {
            background:'#FAD4D4',
            text:'#C44747'
        },
        {
            background:'#FFF8D6',
            text:'#AD7A00'
        },
        {
            background:'#DCF2FF',
            text:'#2378A9'
        }
    ]

    const handleFAQToggleClicked = (questionIdx: number):void => {
        /*
            Handles the question expand and collapse logic

            Args:
                questionIdx: index of the question
         */

        let expandedFAQsList : number[] = [];
        if(expandedFAQs?.includes(questionIdx)){
            expandedFAQsList = expandedFAQs?.filter(idx => idx != questionIdx); 
        }
        else expandedFAQsList = [...expandedFAQs,questionIdx];

        setExpandedFAQs(expandedFAQsList);
    }
    
    useEffect(() => {
    const container = document.getElementsByClassName(
    'help__and__faq__article-body-right'
    )?.[0] as HTMLDivElement;

    container?.scrollTo({ top: 0, behavior: 'auto' });
    }, [articleName]);

    return (
        <div className='help__and__faq__article__wrap'>
            <div className='help__and__faq__article__container'>
                <div className='help__and__faq__article__header-container'>
                    <div className='help__and__faq__article__header'>
                        <div className='help__and__faq__article__header-left'>
                            <div className='help__and__faq__article__header-bread-crumb-container'>
                                <CustomBreadCrumbs breadCrumbs={breadCrumbArray} />
                            </div>
                            <div className='help__and__faq__article__header__heading-container'>
                                <div className='help__and__faq__article__header__heading'>
                                    {articleData?.title}
                                </div>
                            </div>
                        </div>
                        <div className='help__and__faq__article__header-right'>
                            <Icon iconClassName='rms__support__centre__help__and__faq-header-icon' />
                        </div>
                    </div>
                </div>

                <div className='help__and__faq__article__body-container'>
                    <div className='help__and__faq__article__body'>
                        <div className='help__and__faq__article-body-left'>
                            {
                                relatedArticlesList && relatedArticlesList.length > 0 && <div className='help__and__faq__article__body-related-articles-menu-container'>
                                    <div className='help__and__faq__article-body-related-articles-list-header'>
                                        Page Navigator
                                    </div>
                                    <div className='help__and__faq__article-body-related-articles-list'>
                                        {
                                            relatedArticlesList?.map(article=>{
                                                return (
                                                    <div 
                                                    key={`related-article-list-item-${article?.path}`} 
                                                    className={selectedSubArticle === article?.path ? 'help__and__faq__article-body-related-articles-list-item-selected' :  'help__and__faq__article-body-related-articles-list-item'}
                                                    onClick={()=>{handleScrollToArticle(article?.path)}}>
                                                        {article?.label}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }
                            {
                                sectionsList && sectionsList.length > 0  && <div className='help__and__faq__article-body-sections-menu-container'>
                                    <div className='help__and__faq__article-body-sections-list-header'>
                                        Other Help Topics
                                    </div>

                                    <div className='help__and__faq__article-body-sections-list'>
                                        {
                                            sectionsList?.map(section=>{
                                                const isExpanded = expandedSectionMenuItem.includes(section?.id);
                                                return (
                                                    <div
                                                    key={`help-and-faq-section-list-item-${section?.id}`}
                                                    className={!isExpanded && selectedTopic === section?.label?.toLowerCase() ? 'help__and__faq__article-body-sections-list-item-selected'  : 'help__and__faq__article-body-sections-list-item'}
                                                    onClick={()=>{handleToggleSectionListItemExpansion(section?.id)}}
                                                    >
                                                        <div className='help__and__faq__article-body-sections-list-item-label-container'>
                                                            <div className={selectedTopic === section?.label?.toLowerCase() ? 'help__and__faq__article-body-sections-list-item-label-selected' : 'help__and__faq__article-body-sections-list-item-label'}>
                                                                {section?.label}
                                                            </div>
                                                            <Icon iconClassName={isExpanded ? 'rms__down-black-arrow' : 'rms__right-black-arrow'}/>
                                                        </div>
                                                        <div className={isExpanded ? 'help__and__faq__article-body-sub-sections-list-menu-expanded' : 'help__and__faq__article-body-sub-sections-list-menu-collapsed'}>
                                                            {
                                                                section?.guides && section?.guides?.length > 0  && section?.guides.map(subSectionItem=>{
                                                                    return <div 
                                                                    key={subSectionItem?.id}
                                                                    className={articleData?.title === subSectionItem?.label ? 'help__and__faq__article-body-sub-sections-list-item-selected' : 'help__and__faq__article-body-sub-sections-list-item'}
                                                                    onClick={(e)=>handleSubSectionItemClicked(e,section?.label?.toLowerCase(),subSectionItem?.id)}>
                                                                        {subSectionItem?.label}
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )   
                                            })
                                        }
                                    </div>

                                </div>
                            }
                        </div>
                        <div className='help__and__faq__article-body-right'>
                            <div className='help__and__faq__article__content'>
                                <div className='help__and__faq__article__metadata-container'>
                                    <div className='help__and__faq__article__metadata-who'>
                                        <div className='help__and__faq__article__metadata-label'>Who:</div>
                                        <div className='help__and__faq__article__metadata-who-content'>
                                            {articleData?.metadata?.who?.map((item,index)=>{
                                                const colors = allowedRolesTilesColor?.[index%10]
                                                return (
                                                <div
                                                 key={item}
                                                 style={
                                                    {
                                                        backgroundColor:colors?.background,
                                                        color:colors?.text
                                                    }
                                                 }
                                                 className='help__and__faq__article__metadata-who-content-item'
                                                >{startCase(item)}</div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className='help__and__faq__article__metadata-where'>
                                        <div className='help__and__faq__article__metadata-label'>Where:</div>
                                        <div className='help__and__faq__article__metadata-where-content'>
                                            {
                                                articleData?.metadata?.where?.map((item,index)=>{
                                                    if(index === articleData?.metadata?.where?.length-1){
                                                      return <div
                                                        key={item?.label}
                                                        className='help__and__faq__article__metadata-who-content-item'
                                                        onClick={()=>navigate(item?.path)}
                                                        >
                                                            {startCase(item?.label)}
                                                        </div>
                                                    }
                                                    else return (
                                                        <>
                                                            <div
                                                            key={item?.label}
                                                            className='help__and__faq__article__metadata-who-content-item'
                                                            onClick={()=>navigate(item?.path)}
                                                            >
                                                                {startCase(item?.label)}
                                                            </div>
                                                            <div className='help__and__faq__article__metadata-who-content-item-separator'>
                                                               {/* &gt; -> >  */}
                                                               &gt;
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className='help__and__faq__article__metadata-prerequisites'>
                                         <div className='help__and__faq__article__metadata-label'>Prerequisites:</div>
                                         <div className='help__and__faq__article__metadata-prerequisite-content'>
                                            {
                                                articleData?.metadata?.preRequisite?.map((item,index)=>{
                                                    return (
                                                        <div 
                                                            key={`${articleData?.title?.toLowerCase()?.split(' ')?.join('-')}-prerequisite-${index}`}
                                                            className='help__and__faq__article__metadata-prerequisite-content-item'
                                                        >
                                                            <li className=''>{item}</li>
                                                        </div>
                                                    )
                                                })
                                            }
                                         </div>
                                    </div>
                                </div>


                                {
                                articleData?.steps && articleData?.steps?.length > 0 &&   <div className='help__and__faq__article__steps__container'>
                                        <HelpAndFAQArticleSteps steps={articleData?.steps} level = 'primary'/>
                                    </div>
                                }



                                {
                                    articleData?.articles && articleData?.articles?.length > 0 && <div className='help__and__faq__related__articles__container'>
                                    {
                                        articleData?.articles?.map((article,idx)=>{
                                            return <div key={article?.title?.toLowerCase()?.split(' ')?.join('-')+'-related-article-'+{idx}} id={article?.title?.toLowerCase()?.split(' ')?.join('-')} className='help__and__faq__related__article__container'> 
                                                <div className='help__and__faq__related__article-header'>
                                                    <div className='help__and__faq__related__article-title'>
                                                        {article?.title}
                                                    </div>
                                                    {
                                                       article?.description && <div className='help__and__faq__related__article-description'>
                                                            {article?.description}
                                                        </div>
                                                    }
                                                </div>

                                                {
                                                   article?.steps && article?.steps?.length > 0 && <div className='help__and__faq__related__article__steps__container'>
                                                     <HelpAndFAQArticleSteps steps={article?.steps} level={'primary'} />
                                                   </div>
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                                }

                                {
                                    articleData?.faqs && articleData?.faqs?.length > 0 && <div className='help__and__faq__faqs__container'>
                                        <div className='help__and__faq__faqs__header'>
                                            Most Frequently Asked Questions
                                        </div>
                                    
                                        <div className='help__and__faq__faqs__body__container'>
                                            {
                                               articleData?.faqs?.map((faq,idx)=>{
                                                return (
                                                    <div key={articleName+'-faq-'+idx}>
                                                        <div className='help__and__faq__faqs__body__container-faq-question'>
                                                            <div className='help__and__faq__faqs__body__container-faq-question-left'>
                                                                <div className='help__and__faq__faqs__body__container-faq-question-bullet'></div>
                                                                 <div className='help__and__faq__faqs__body__container-faq-question-content'>{faq?.question}</div>
                                                            </div>
                                                            <div className='help__and__faq__faqs__body__container-faq-question-right'>
                                                                <div className='help__and__faq__faqs__body__container-faq-toogle-btn'
                                                                onClick={()=>handleFAQToggleClicked(idx)}>
                                                                    {expandedFAQs?.includes(idx) ? '-' : '+'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={expandedFAQs?.includes(idx) ? 'help__and__faq__faqs__body__container-faq-answer-expanded': 'help__and__faq__faqs__body__container-faq-answer-collapsed'}>{faq?.answer}</div>
                                                    </div>
                                                )
                                               })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HelpAndFAQArticle;